import React, { useState } from "react";
import PackageContext from "./ModalContext";

const Provider = ({ children }) => {
    const [state, setState] = useState({
        modalMode: false
    });
    return (
        <PackageContext.Provider
            value={{
                data: state,
                updateModalMode: () => {
                    setState({ ...state, modalMode: !state.modalMode });
                }
            }}
        >
            {children}
        </PackageContext.Provider>
    );
};

export default Provider;